"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlListService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const access_control_list_repository_1 = require("./access-control-list.repository");
let AccessControlListService = class AccessControlListService {
    constructor(accessControlListRepository) {
        this.accessControlListRepository = accessControlListRepository;
    }
    /**
     * Delegates the userId to the repository to get the user permissions
     */
    async getUserPermissions(userId, categoryKey) {
        return this.accessControlListRepository.getUserPermissions(userId, categoryKey);
    }
    async getAclMetadata() {
        return this.accessControlListRepository.getAclMetadata();
    }
    async getRoleAcl(roleId) {
        return this.accessControlListRepository.getRoleAcl(roleId);
    }
    async updateRoleAcl(roleId, aclIds) {
        return this.accessControlListRepository.updateRoleAcl(roleId, aclIds);
    }
};
exports.AccessControlListService = AccessControlListService;
exports.AccessControlListService = AccessControlListService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof access_control_list_repository_1.AccessControlListRepository !== "undefined" && access_control_list_repository_1.AccessControlListRepository) === "function" ? _a : Object])
], AccessControlListService);
